const CryptoJS = require('crypto-js');

const keyBytes = 32; // 32 bytes = 256 bits
const keyWordArray = CryptoJS.lib.WordArray.random(keyBytes);
const wrappedSessionKey = CryptoJS.enc.Base64.stringify(keyWordArray);


function getWrappedSessionKey(){
    return localStorage.getItem("wrappedSessionKey") || null;
}

function setWrappedSessionKey(){
    if (getWrappedSessionKey()){
    }else {
        localStorage.setItem("wrappedSessionKey", wrappedSessionKey);
    }
}
setWrappedSessionKey();

/**
 * Encrypts a plaintext string using AES encryption.
 * @param {string} plaintext - The string to encrypt.
 * @returns {string} The encrypted ciphertext as a Base64 string.
 */
export function encryptToken(plaintext) {
    // Use AES to encrypt the string.
    const ciphertext = CryptoJS.AES.encrypt(plaintext, getWrappedSessionKey());
    // Convert the CipherParams object to a string format (e.g., Base64).
    return ciphertext.toString();
}

/**
 * Decrypts a ciphertext string using AES encryption.
 * @param {string} ciphertext - The encrypted string to decrypt.
 * @returns {string} The original plaintext string.
 */
export function decryptToken(ciphertext) {
    // Use AES to decrypt the ciphertext.
    const bytes = CryptoJS.AES.decrypt(ciphertext, getWrappedSessionKey());
    // Convert the decrypted WordArray to a UTF-8 string.
    return bytes.toString(CryptoJS.enc.Utf8);
}
